import DropdownView from './dropdown-view'

export default DropdownView
